module.exports = __webpack_public_path__ + "static/PIO-CAN-2000-M-058a90af01f2c79373c03be1f6eeaae1.jpg";